import React, { useCallback, useEffect, useState } from "react";
import {
  getAllNotificationTypeWise,
  updateNotificationAction
} from "../../redux/services/notification.service";
import { NotificationType } from "../../constants/NotificationType";
import { customStylesForGrid } from "../../constants/helper";
import CommonDataTable from "../../components/common/CommonDataTable";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { NotificationAction } from "../../constants/NotificationAction ";
import { FaEye, FaTrash } from "react-icons/fa";
import { confirmAction } from "../../components/common/commonAlert";

export default function NotificationListModal({
  show,
  onHide,
  notificationType,
  setRefreshNotification
}) {
  const navigate = useNavigate();
  const [tableState, setTableState] = useState({
    recordData: [],
    headerName: "",
    recordTotal: 0,
    sortDirection: "asc",
    pageNo: 1,
    pageSize: 10
  });

  const [notificationTypeReqModel, setNotificationTypeReqModel] = useState({
    WebuserId: 0,
    SearchText: "",
    NotificationTypeId: notificationType,
    FilterBy: 1,
    SortCol: "notificationId",
    SortDir: "desc",
    PageNo: 1,
    PageSize: 10,
    RefreshTrigger: 0
  });
  const handleNotificationClick = (url) => {
    if (url) {
      navigate(url);
    }
  };
  const handleRead = async (notificationId) => {
    const payload = {
      notificationId,
      action: NotificationAction.Read
    };
    const response = await updateNotificationAction(payload);
    if (response.statusCode === 200) {
      setRefreshNotification(true);
      setTableState((prev) => ({
        ...prev,
        recordData: prev.recordData.map((item) =>
          item.notificationId === notificationId ? { ...item, isRead: true } : item
        )
      }));
    }
  };
  const showConfirmation = (notificationId) => {
    confirmAction(
      `Are you sure you want to delete this notification?`,
      () => handleDelete(notificationId),
      "Yes",
      "question"
    );
  };

  const handleDelete = async (notificationId) => {
    const payload = {
      notificationId,
      action: NotificationAction.Delete
    };
    const response = await updateNotificationAction(payload);
    if (response.statusCode === 200) {
      setNotificationTypeReqModel((prev) => ({
        ...prev,
        RefreshTrigger: prev.RefreshTrigger + 1
      }));
      setRefreshNotification(true);
    }
  };

  const columns = [
    {
      name: "Notification",
      columnName: "notificationId",
      grow: 1,
      cell: (row) => (
        <div
          className={row.isRead ? "w-100 py-2 " : "notification-unread w-100 py-2 "}
          onClick={() => handleNotificationClick(row.notificationURL)}
          style={{
            cursor: "pointer",
            fontWeight: 300
          }}>
          <div dangerouslySetInnerHTML={{ __html: row.notificationText }} />

          <div className="d-flex justify-content-between align-items-center mt-1">
            <small className="text-muted">
              <i className="bi bi-clock me-1"></i>
              {moment(row.notificationDate).format("DD/MM/YYYY HH:mm")}
            </small>

            <div>
              {!row.isRead && (
                <button
                  className="btn btn-link p-0 me-2"
                  title="Read"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent opening notification
                    handleRead(row.notificationId);
                  }}>
                  <FaEye />
                </button>
              )}
              <button
                className="btn btn-link p-0 text-danger"
                title="Delete"
                role="button"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                  showConfirmation(row.notificationId);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.stopPropagation();
                    showConfirmation(row.notificationId);
                  }
                }}>
                <FaTrash />
              </button>
            </div>
          </div>
        </div>
      )
    }
  ];
  const handlePageNo = (page) => {
    setTableState((prev) => ({
      ...prev,
      pageNo: page
    }));

    setNotificationTypeReqModel((prev) => ({
      ...prev,
      PageNo: page
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setTableState((prev) => ({
      ...prev,
      pageSize
    }));

    setNotificationTypeReqModel((prev) => ({
      ...prev,
      PageSize: pageSize,
      PageNo: 1
    }));
  };
  const handleSort = (columnName, sortDirection) => {
    setTableState((prev) => ({
      ...prev,
      sortDirection
    }));

    setNotificationTypeReqModel((prev) => ({
      ...prev,
      SortCol: columnName,
      SortDir: sortDirection
    }));
  };

  const handelViewAll = useCallback(async () => {
    const startRow = notificationTypeReqModel.PageSize * (notificationTypeReqModel.PageNo - 1);
    const qry = `?searchText=${encodeURIComponent(
      notificationTypeReqModel?.SearchText || ""
    )}&notificationTypeId=${
      notificationTypeReqModel?.NotificationTypeId ?? ""
    }&filterBy=${notificationTypeReqModel?.FilterBy}
  &sortCol=${notificationTypeReqModel?.SortCol || ""}
  &sortDir=${notificationTypeReqModel?.SortDir || ""}
  &startRow=${startRow}
  &pageSize=${notificationTypeReqModel?.PageSize}`;

    const response = await getAllNotificationTypeWise(qry);
    if (response.statusCode === 200) {
      setTableState((prev) => ({
        ...prev,
        recordTotal: response.data.recordsTotal,
        recordData: response.data.data
      }));
    }
  }, [notificationTypeReqModel]);

  useEffect(() => {
    if (!notificationTypeReqModel?.NotificationTypeId) return;
    setTimeout(() => {
      handelViewAll(notificationTypeReqModel.NotificationTypeId);
    }, 0);
  }, [notificationTypeReqModel]);
  if (!show) return null;

  return (
    <div className="container">
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-xl modal-dialog-centered p-5">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {notificationType == NotificationType.ActionRequired
                  ? "Actions Required"
                  : "General"}
              </h5>

              <button type="button" className="btn-close" onClick={onHide}></button>
            </div>

            <div className="modal-body">
              <div className="container p-0 m-0 row mw-100">
                <CommonDataTable
                  columns={columns}
                  data={tableState.recordData}
                  customStyles={customStylesForGrid}
                  pageNo={notificationTypeReqModel.PageNo}
                  pageSize={notificationTypeReqModel.PageSize}
                  recordTotal={tableState.recordTotal}
                  handlePageNo={(page) => {
                    handlePageNo(page);
                  }}
                  handlePageSizeChange={(pageSize) => {
                    handlePageSizeChange(pageSize);
                  }}
                  onSort={(column, sortDirection) => handleSort?.(column.columnName, sortDirection)}
                  enablePagination={true}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onHide}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
